// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"addc4488","354":"2aecad3c","391":"43f1d75c","455":"e021a6ef","488":"1a9a8f8c","685":"729ef1fc","977":"3d2c2926"}[chunkId] + ".chunk.js";
};